export const IDENTITY_TOKEN_KEY = "identityToken";
export const ACCESS_TOKEN_KEY = "accessToken";
export const ENVIRONMENT_KEY = "environment";
